import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../hooks/redux';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedUserTypes?: ('admin' | 'doctor')[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedUserTypes }) => {
  const { token, userType } = useAppSelector((state) => state.auth);
  const location = useLocation();

  // Which portal is this route guarding? Used to send unauthenticated
  // visitors to the matching login page instead of a generic one.
  const isDoctorPortal =
    allowedUserTypes?.includes('doctor') || location.pathname.startsWith('/doctor');
  const loginPath = isDoctorPortal ? '/doctor/login' : '/admin/login';

  // Not logged in → go to the portal's login, remembering where they were headed.
  if (!token) {
    return <Navigate to={loginPath} replace state={{ from: location }} />;
  }

  // Logged in as the wrong user type for this portal → send to its login.
  if (allowedUserTypes && userType && !allowedUserTypes.includes(userType)) {
    return <Navigate to={loginPath} replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
